import { Component } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { ServiceCategoryService } from '../services/service.category.service';

import { ServiceCategory } from '../models/service.category.model';
import { NotificationService } from '../services/notification.service';
import { LookupService } from '../services/lookup.service';

@Component({
  selector: 'app-service-category-list',
  templateUrl: './service-category-list.component.html'
})
export class ServiceCategoryListComponent {

  constructor(public service: ServiceCategoryService, public lookupService: LookupService, private modalService: NgbModal, private notificationService: NotificationService) { }

  ngOnInit() {
    this.lookupService.getServiceTypes();
    this.onSearch();
  }

  closeResult = '';
  model = new ServiceCategory();
  modelSearch = new ServiceCategory();

  open(content, model) {
    if (model == null)
      model = new ServiceCategory();

    this.model = Object.assign({}, model);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }

  onArchive(id) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.service.archive(id).subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.onSearch();
      },
      err => { console.log(err); }
    );

  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = this.modelSearch;
    this.service.search();
  }
}

